<template>
    <div>
        <form id="credit" target="_top">
            <input type="hidden" name="_token" :value="csrf_token">
            <input type="hidden" name="memo" :value="memo">
        </form>
    </div>
</template>

<script>
    export default {
        name: "credit-regist",
        props: ['csrf_token', 'order_site', 'memo'],
        data: function () {
            return {
                characters: Object,
            }
        },
        mounted() {
            this.regist();
        },
        methods: {
            regist: function() {
                let form = document.forms['credit'];
                form.action = this.order_site+'/confirm_credit.php';
                form.method = 'POST';
                axios.default
                    .post('/purchase/regist', {pay_kind: 'credit'})
                    .then(response => {
                        for(const key in response.data) {
                            form.innerHTML+='<input type="hidden" name="'+key+'" value="'+response.data[key]+'">';
                        }
                        form.submit();
                    });
            }
        }
    }
</script>

<style scoped>
</style>
